var _path, _path2, _rect, _path3, _rect2, _path4, _circle, _circle2, _circle3, _circle4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle5, _circle6, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _ellipse, _path31, _ellipse2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _ellipse3, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _ellipse4, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumPartnerBannerIllustrationLargeDark = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 278,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#312823",
    d: "M420.62 257.619c103 59.904-122.295 38.761-218.117 38.761C106.68 296.38 29 264.645 29 251.579s77.68-23.659 173.503-23.659 192.229-9.061 218.117 29.699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#256652",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m347.453 125.137-6.843 28.352-31.774-2.933 3.911-100.698s9.436-5.539 16.131-5.866c11.687-.572 20.042 1.468 26.397 14.176s-7.822 66.969-7.822 66.969Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 83.101,
    height: 12.71,
    x: 258.977,
    y: 152.508,
    fill: "#256652",
    rx: 6.355
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M307.859 165.215h29.431s4.792-1.955 4.786-6.022c-.006-4.56-3.206-5.982-3.206-5.982"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 66.481,
    height: 12.71,
    x: 266.797,
    y: 230.719,
    fill: "#256652",
    rx: 6.355
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#173F33",
    d: "M301.511 236.122a6.356 6.356 0 0 1-6.28-6.429l.762-64.808 12.709.15-.762 64.807a6.356 6.356 0 0 1-6.429 6.28"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 274.126,
    cy: 247.837,
    r: 4.399,
    fill: "#256652"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.329,
    cy: 247.103,
    r: 4.399,
    fill: "#173F33"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.923,
    cy: 247.837,
    r: 4.399,
    fill: "#256652"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.524,
    cy: 247.837,
    r: 4.399,
    fill: "#256652"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9D86",
    d: "m313.388 52.358.422-5.038-7.249.893-.342 3.572-4.91.573s4.891 7.431 7.352 6.217 5.417-5.003 7.878-6.217z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4,
    d: "M316.5 51.798s-5.417 5.004-7.878 6.218-7.768-5.34-7.768-5.34 4.018-.446 5.142-.878c1.125-.431.216-4.032.216-4.032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B35C35",
    fillRule: "evenodd",
    d: "m342.998 147-10.011-44.762 1.289 15.12c-18.035 6.027-48.335 2.658-48.859-2.855l-.328-9.835 2.99-23.035s-2.462 3.588-13.077 3.808c-7.821.163-13.207-7.281-13.207-7.281V44.18h16.436v19.907s5.047-6.789 8.701-9.86c2.937-2.467 6.285-2.421 6.285-2.421h7.939s1.57 2.022 4.708 4.044c1.92 1.237 3.138 1.011 3.138 1.011 1.57-1.01 3.96-2.633 3.96-2.633l4.41-2.424s7.39-.139 11.18 1.098c4.675 1.525 7.076 2.669 11.298 5.45 7.005 4.615 10.148 17.148 10.148 17.148L352.33 87c.556 2.234 2.668 19 2.817 23.5.115 3.475 2.501 36.5 2.501 36.5z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.81,
    d: "m344.953 145.628 10.28 1.303s2.447 13.096 1.726 14.591c-.72 1.494-.582.451-.582.451m-10.755 2.284s.307 1.632 1.096-.383c.79-2.016 1.755-9.304 1.755-9.304m.537 11.725s.376 1.111 1.097-.383c.72-1.494.865-10.481.865-10.481m1.396 9.191s.889 1.178 1.165-.905-.438-8.534-.438-8.534M345.154 152.003s-1.339 1.911-2.468 2.852c-1.003.835-2.844 1.742-2.844 1.742"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9D86",
    d: "M344.957 145.626s-8.746 11.883-4.529 10.526c.909-.293 1.799-1.002 2.561-1.78 1.308-1.338 2.237-2.883 2.237-2.883l-.045 12.179s.751 2.219 1.541.204 1.755-9.303 1.755-9.303l.093 11.137s.82 1.698 1.54.204.866-10.481.866-10.481l.437 8.534s1.848 1.835 2.124-.248-.438-8.534-.438-8.534l2.254 6.655s.89 1.179 1.61-.316-1.726-14.591-1.726-14.591z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.405,
    d: "m351.998 84.504 2.5 21.496 3.096 40.181M333.816 109.844l.528 6.957s-1.056 2.865-24.293 2.865-24.82-4.502-24.82-4.502"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9D86",
    d: "M296.623 33.583c2.052 9.705 2.893 12.85 10.036 15.086 7.143 2.235 11.836-5.802 13.302-12.594 1.467-6.792-6.967-16.55-13.705-17.437-4.425 1.419-11.078 4.52-9.633 14.945"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.405,
    d: "M303.384 38.68c2.707 1.973 5.61.831 8.29-.513 2.681-1.344-1.927 3.728-4.103 3.772-2.072.041-4.187-3.259-4.187-3.259"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.405,
    d: "M305.686 29.262c-1.139-.754-1.483-.82-2.488-.71-.926.1-2.133 1.066-2.133 1.066m16.549 13.094s-4.419 6.997-9.225 6.31c-3.398-.485-4.368-1.456-4.368-1.456"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4,
    d: "M309.352 28.785s1.201-1.066 2.133-1.066 2.132 1.066 2.132 1.066"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.244,
    cy: 1.244,
    r: 1.244,
    fill: "#0F0F0F",
    transform: "scale(-1 1)rotate(-7.498 81.221 2341.304)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.244,
    cy: 1.244,
    r: 1.244,
    fill: "#0F0F0F",
    transform: "scale(-1 1)rotate(-7.498 73.867 2402.376)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M297.612 18.412a14.1 14.1 0 0 0-1.731 5.148c-.311 2.366-.189 3.12.343 2.993-.205 1.23-.856 5.382-.452 6.191a70 70 0 0 1 1.132 2.442s.269-1.665.215-6.198c-.02-1.674.179-2.731.439-3.4l.42-.382q.35-.322.754-.682c.736-.655 1.604-1.38 2.597-2.03.453-.296.896-.81 1.358-1.346.869-1.008 1.803-2.091 2.981-1.936.781.103 1.661.419 2.589.878l7.833 5.712q.35.312.676.61l.443 5.568s1.034 1.277.913 2.195l-.805 6.12s.1 1.31.322 2.117c.604 2.202 1.214 3.822 3.265 4.877 1.038.534 4.059 1.127 4.059 1.127s-3.228-2.617-4.228-4.41c-.512-.919-.697-1.767-.905-2.728q-.07-.326-.15-.672c-.94-4.031.713-9.986.713-9.986l.068-.004c.526.465 1.169.775 2.218.913.595-.142.841-1.821 1.013-3.127.336-2.554-.01-5.164-.904-7.55.932-.483 1.691-1.21 2.159-2.154 1.374-2.766-.267-6.349-3.666-8.002-2.956-1.438-6.268-.943-7.985 1.031a12 12 0 0 0-1.556-.309 14.2 14.2 0 0 0-4.113.057c-.923-2.671-4.203-4.254-7.663-3.585-3.71.717-6.223 3.753-5.612 6.78.341 1.69 1.584 3.02 3.26 3.742",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9D86",
    d: "M295.277 212.818c-.227-2.77-.992-2.895-.992-2.895l6.88-5.521s1.738 2.698 3.243 4.041c1.429 1.274 2.709 1.295 4.097 2.617.974.928 2.04 1.395 2.162 2.694.108 1.165-1.303 2.522-1.303 2.522l-14.165 11.367-3.603-4.489s3.908-7.566 3.681-10.336M292.277 231.464l-3.243-4.04s-1.069 1.411-1.303 2.522c-.313 1.487.543 3.993.543 3.993z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#256652",
    d: "M288.856 226.908s.503-1.347.989-2.123c.555-.885 1.724-2.048 1.724-2.048l4.864 6.061-3.686 2.958z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#256652",
    d: "m287.842 232.364.239 1.136 24.661-20.455s1.184.637 1.706 1.288c.522.65.888 1.945.888 1.945l-25.395 20.38s-.69-.215-1.058-.48c-.492-.355-.717-.661-.973-1.212-.426-.918-.068-2.602-.068-2.602"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.405,
    d: "m312.746 213.062-17.613 14.135-3.242-4.041"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9D86",
    d: "M236.065 212.61c1.973-1.698 1.594-4.958 1.594-4.958l9.245 1.972s.314 1.944.271 3.766c-.04 1.729-.756 3.546 2.3 6.847.832.899.564 3.356-.351 4.163-.821.724-2.784.466-2.784.466l-20.14-3.764 1.188-5.574s6.704-1.22 8.677-2.918M223.524 221.061l.972-4.561s-1.781.018-2.784.466c-1.344.601-2.703 2.603-2.703 2.603z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#256652",
    d: "M224.707 216.002s-2.045.402-1.136.288c.431-.054 1.276-1.333 2.487-1.589 1.702-.359 3.409-.332 3.409-.332l-1.727 8.107-4.623-.985z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#256652",
    d: "m220.467 218.274-.73.904 30.525 5.978s.256 1.321.082 2.137-.946 1.917-.946 1.917l-31.845-6.789s-.271-.671-.298-1.123c-.036-.607.059-.974.324-1.521.442-.91 2.888-1.503 2.888-1.503"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.405,
    d: "m250.256 225.174-22.086-4.708 1.08-5.068"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#7889B3",
    d: "m286.648 157.23 25.373 44.574-27.235 15.627-8.93-20.538s-4.138-7.667-8.347-15.377l-9.613 30.111-31.599-5.804s17.748-36.89 26.807-56.828c-.29-1.751-.465-3.517-.465-5.233 0-10.269 38.844-24.561 38.844-24.561h14.287c25.301 1.28 26.789-1.779 26.789-1.779s6.25 6.695 6.25 20.536c0 23.299-34.17 21.719-52.161 19.272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#566280",
    strokeLinecap: "round",
    d: "m287.1 158.046 24.955 43.676-27.177 15.746-9.026-19.547s-4.042-8.989-5.839-11.686m63.326-68.766s6.613 6.796 5.642 21.844c-1.908 29.563-63.129 16.809-63.129 16.809L257.785 212.1l-16.891-3.579-15.019-2.505s28.215-55.737 31.91-65.625 40.523-10.338 40.523-10.338"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9D86",
    d: "m275.232 43.87-9.001.017s-1.254.209-2.696-1.586c-1.441-1.796-3.054-5.873-3.054-5.873s-.358-1.349.122-1.983c.343-.453 1.289-.774 1.289-.774s-.282-1.14.104-1.7c.49-.71 2.216-.716 2.216-.716s-.372-1.357.122-1.983c.411-.52 1.598-.755 1.598-.755l2.421 1.002.471-7.399s.116-2.394 1.666-2.137c1.099.183 1.733 2.097 1.733 2.097l.15 7.685.948-5.343s1.136-3.343 2.665-2.965c1.528.378 1.097 2.342 1.097 2.342l-1.174 9.026s2.731 1.02 2.592 3.286-2.734 3.277-3.147 5.777c-.127.766-.122 1.983-.122 1.983"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m266.228 43.9 4.501-.008 4.501-.009s-.005-1.216.121-1.982c.413-2.5 3.009-3.512 3.147-5.777.139-2.265-2.591-3.286-2.591-3.286l1.174-9.026s.431-1.964-1.098-2.342c-1.528-.378-1.994 2.152-1.994 2.152m-3.502-3.625c-1.55-.258-1.755 3.303-1.755 3.303l-.381 6.232-2.422-1.002s-1.187.234-1.598.755c-.494.625-.121 1.983-.121 1.983s-1.727.007-2.217.717c-.386.56-.104 1.7-.104 1.7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m268.848 31.535 2.317 2.701s.304 1.153-.104 1.7c-.679.91-3.092-.19-3.092-.19m0 0-3.759-4.495m3.759 4.495s.636 1.872-.156 2.549c-.394.336-1.272.49-1.272.49l-4.103-3.947m10.461 1.494s-.855.59-1.306 1.057c-.466.481-1.015 1.36-1.015 1.36"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#173F33",
    d: "M298.567 19.059c-3.785 4.365-1.955 15.638-1.955 15.638l-1.467-2.444s-1.893-10.614 1.956-15.635c4.039-5.27 8.151-6.185 14.664-4.892 6.89 1.368 12.269 5.258 13.198 12.22.383 2.864-.977 7.333-.977 7.333l-1.467-.488.489-6.844c.191-2.673-6.488-9.064-12.709-9.777-5.219-.597-8.29.92-11.732 4.889"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#173F33",
    d: "M296.673 36.155c0 .919.014 1.33-.272 2.07-.286.741.058 2.161-.403 2.438s-1.228-.132-1.686-.427c-.458-.294-1.331-1.329-1.609-2.08s-.423-1.652-.413-2.57c.009-.919.173-1.808.466-2.538s.702-1.263 1.166-1.522 1.958-.378 2.413-.066l-1.77 4.211z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.884,
    cy: 35.968,
    fill: "#256652",
    rx: 1.798,
    ry: 4.695
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#256652",
    d: "M325.571 34.03c0 .919.02 1.33-.362 2.07-.381.741.528 1.494-.087 1.771s-2.722.063-3.333-.23c-.611-.295-1.14-.859-1.511-1.61s-.564-1.652-.551-2.57c.013-.919.231-1.808.622-2.537.392-.73.937-1.264 1.555-1.523.619-.26 2.611-.378 3.218-.066l-2.361 4.211z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.785,
    cy: 33.548,
    fill: "#173F33",
    rx: 3.035,
    ry: 4.321
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#807B75",
    d: "m231.097 112.928.001 2.92 24.426.749z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m224.498 64 3.824 24.573 1.94 12.907 1.766 11.214a1 1 0 0 1-1.084 1.151l-62.419-6.039"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    stroke: "#858585",
    d: "M227.242 88.202h-.001l-.001-.01-3.175-23.638a.5.5 0 0 0-.496-.433h-61.781a.5.5 0 0 0-.493.58l6.953 42.704a.5.5 0 0 0 .449.418l61.785 5.527a.5.5 0 0 0 .539-.574z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D46C3B",
    stroke: "#D46C3B",
    d: "M191.08 88.181c.186-1.57 1.427-2.508 3.042-2.765 2.236-.356 4.794 1.509 4.431 3.668-.309 1.84-2.188 2.868-4.11 2.636s-3.583-1.686-3.363-3.539Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#424040",
    d: "M256.024 117.693a1 1 0 0 0-.908-1.117l-22.604-1.923a1 1 0 0 0-1.078.876l-.146 1.21-.142 1.175a1 1 0 0 0 .873 1.112l22.508 2.721a1 1 0 0 0 1.113-.873z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M255.652 121.147a.5.5 0 0 1-.544.451l-24.137-2.25a.5.5 0 1 1 .093-.995l24.137 2.25a.5.5 0 0 1 .451.544",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "m231.531 114.328-63.544-6.073v3.632l62.908 7.702z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4,
    d: "m167.885 108.257 63.662 5.949-.231 3.519"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF48D",
    strokeOpacity: 0.1,
    d: "m225.125 65.969 7.295 47.774",
    shapeRendering: "crispEdges"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2626",
    d: "M331.932 112.445s4.122.008 3.873 6.462-7.172 11.033-7.11 9.42"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#424040",
    stroke: "#000",
    d: "M310.672 108.86a74 74 0 0 0 3.122.787c2.117.486 4.786 1.001 6.911 1.083s4.825-.225 6.973-.547a77 77 0 0 0 3.232-.555q.018.314.041.769c.04.833.081 1.993.089 3.301.014 2.627-.112 5.803-.654 8.121-.394 1.687-1.178 3.64-1.872 5.188a54 54 0 0 1-1.137 2.37l-13.793-.533-.188-.483a70 70 0 0 1-.727-1.986c-.56-1.606-1.194-3.622-1.513-5.315-.442-2.344-.558-5.54-.561-8.174a102 102 0 0 1 .077-4.026Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#CC826B",
    d: "M320.661 110.302c3.621.116 8.743-1.261 9.878-1.581.153-.043.325-.143.267-.29-.156-.393-1.511-1.193-9.667-1.509-7.213-.279-9.615.51-10.414 1.087-.34.245-.131.618.276.718 1.696.418 6.251 1.466 9.66 1.575Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9FB",
    d: "M317.79 123.795a4 4 0 0 1-.858-.115q-.373-.096-.364-.315.001-.048.043-.217a2 2 0 0 1 .101-.311q.066-.141.155-.138.014 0 .15.033.176.048.304.08.136.026.307.033.901.034 1.312-.305.416-.34.447-1.125l.227-5.889q.01-.273.496-.254l.095.004q.493.019.481.292l-.222 5.765q-.047 1.209-.695 1.861-.64.653-1.979.601m6.051.234a5.2 5.2 0 0 1-1.245-.192q-.567-.172-.908-.391-.333-.225-.327-.395a.64.64 0 0 1 .085-.25q.089-.154.195-.273.108-.12.169-.117.055.002.235.119.415.234.826.394t1.005.183q.465.018.834-.146t.579-.477a1.4 1.4 0 0 0 .234-.744q.018-.45-.217-.754a1.7 1.7 0 0 0-.569-.494q-.334-.19-.981-.475a9 9 0 0 1-1.107-.549 2.1 2.1 0 0 1-.677-.717q-.27-.463-.241-1.207.025-.649.38-1.148.354-.507.98-.77.627-.262 1.425-.232.363.014.823.135.46.113.782.297.328.184.32.388a.6.6 0 0 1-.084.243q-.075.149-.175.267-.1.12-.155.117-.062-.002-.242-.112a3.7 3.7 0 0 0-.598-.283 2.3 2.3 0 0 0-.727-.13q-.704-.029-1.154.318-.445.345-.47.994-.015.389.167.649.181.26.469.422t.806.38q.035.009.155.061.714.308 1.161.592.454.278.756.782.309.504.28 1.269-.028.718-.383 1.237a2.14 2.14 0 0 1-.975.784q-.618.256-1.431.225"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "#424040",
    strokeWidth: 4,
    d: "m184.381 234.289-18.752-113.895-39.935-4.918-27.818 125.372M344.463 256.712l-16.689-120.123-47.432-2.997-22.244 120.367"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D3E36",
    d: "M85.54 103.953a1 1 0 0 1 1.11-.958l191.693 21.466a1 1 0 0 1 .879 1.134l-2.878 20.287a1 1 0 0 1-1.173.842L86.12 111.537a1 1 0 0 1-.817-1.019z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#665C59",
    d: "M338.533 130.621a1 1 0 0 0-.908-1.123l-57.127-4.807a1 1 0 0 0-1.072.844l-3.144 20.436a1 1 0 0 0 1.136 1.141l59.416-8.877a1 1 0 0 0 .844-.864z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#593221",
    d: "M39.878 227.953a10 10 0 0 1 9.944-8.945h7.133a10 10 0 0 1 9.92 8.737l3.714 29.173s-10.495 2.355-17.294 2.311c-6.488-.041-16.49-2.311-16.49-2.311z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.495,
    cy: 222.435,
    fill: "#663A26",
    rx: 10.698,
    ry: 3.771
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#256652",
    d: "M90.22 204.929s-6.327 2.811-10.582 2.904c-4.993.108-12.417-3.416-12.417-3.416s.777-6.264 2.451-9.749c1.872-3.896 4.706-6.499 4.706-6.499-.333 1.326 3.364 5.356 3.364 5.356l-.471-10.339s8.29-4.578 13.916-4.245c9.562.566 20.004 15.827 20.004 15.827-4.87 6.484-8.625 8.626-17.35 9.384l-.376-8.723-1.812.392z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#173F33",
    d: "m102.857 197.007-2.208-4.326M74.753 196.914l9.766 5.447M85.394 192.482l1.616-4.64M51.543 226.242s.508-10.788 6.196-18.087 20.242-13.684 30.257-16.162c8.87-2.195 21.419 3.359 21.419 3.359"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#173F33",
    d: "M29.893 173.415s3.563 6.477 6.922 9.391c3.944 3.421 11.782 5.554 11.782 5.554s2.735-5.538 3.26-9.449c.588-4.372-.287-8.35-.287-8.35-.444 1.285-5.567 2.046-5.567 2.046l5.92-7.97s-4.19-9.204-8.877-12.693c-7.966-5.931-24.513-.674-24.513-.674.428 8.447 2.289 12.671 8.874 19.104l4.976-6.738 1.242 1.523z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#256652",
    d: "m23.002 158.485 4.087-1.992M46.59 177.308l-10.744-2.156M40 167l.816-2.577.816-2.576M56.313 226.203s3.378-9.424 3.125-19.365-11.21-28.564-18.919-39.017c-6.829-9.259-20.854-14.932-20.854-14.932"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F2317",
    fillRule: "evenodd",
    d: "M245.995 42.173c4.017 1.678 8.001 5.023 8.907 8.415.849 3.179-2.836 4.59-4.884 6.648-1.407 1.412-2.574 3.076-5.004 3.282-2.363.2-4.904-1.115-7.398-2.23-2.964-1.327-6.855-2.207-8.139-4.72s1.559-3.995 2.687-5.953c1.067-1.85 1.397-4.13 3.633-5.01 2.92-1.149 6.507-1.974 10.198-.432",
    clipRule: "evenodd",
    opacity: 0.9
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3642A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m241.753 45.094-7.374.51 3.27 5.43m10.584-5.708-9.925 9.323m9.791-6.135 2.94 6.067-6.25.3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F2317",
    fillRule: "evenodd",
    d: "M137.73 31.788c3.201-.07 6.528.884 8.667 2.955 2.185 2.115 3.058 5.08 2.414 7.775-.59 2.47-3.257 3.902-5.574 5.453-2.267 1.517-4.495 3.366-7.43 3.247-3.069-.125-5.688-1.87-7.718-3.863-2.08-2.044-4.041-4.555-3.499-7.156.518-2.492 3.687-3.6 6.052-5.114 2.231-1.428 4.252-3.235 7.088-3.297",
    clipRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3642A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m129.648 34.632-5.621 7.001 9.745 3.005m2.119-11.37 9.987 3.593-5.863 6.413"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#D46C3B",
    stroke: "#E3642A",
    d: "m131.989 35.362 2.125 4.148-.747-4.763s-.775-.518-1.131-.24c-.273.214-.247.855-.247.855Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.298,
    cy: 1.294,
    fill: "#D46C3B",
    rx: 1.298,
    ry: 1.294,
    transform: "matrix(1.00247 .096 -.0978 .98803 134.008 40.188)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F2317",
    fillRule: "evenodd",
    d: "M202.311 27.39c2.628 2.644 4.476 6.208 4.408 9.659-.069 3.525-1.923 6.62-4.76 8.222-2.598 1.467-5.972.36-9.165-.361-3.124-.705-6.504-1.111-8.755-3.681-2.354-2.687-2.952-6.282-2.863-9.581.091-3.38.681-7.031 3.354-8.644 2.562-1.546 6.057.244 9.258 1.034 3.019.745 6.196 1.01 8.523 3.352",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3642A",
    d: "M189.468 32.96s1.708-.922 2.891-.774c1.234.155 2.717 1.577 2.717 1.577m-5.608-.803-.427 3.123 5.608.804.427-3.124m-5.608-.803s.545-1.65.371-2.719c-.197-1.213-1.515-2.856-1.515-2.856s-1.206-1.985-1.158-3.333c.086-2.382 1.634-4.067 4.158-4.682 1.786-.435 3.042-.067 4.745.68 1.531.672 2.502 1.23 3.311 2.586.968 1.623.785 2.922.245 4.654-.635 2.032-2.662 2.325-3.656 4.226-.44.841-.893 2.247-.893 2.247"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3642A",
    strokeWidth: 0.5,
    d: "M194.154 30.914c-.52-.324.543-5.709 1-6.5.38-.657.993-.833 1.644-.423.155.097.29.501.195.835-.397 1.394-2.34.527-3.567.386-.988-.115-2.151-.203-2.387-1.328-.14-.671.207-1.055.787-1.234.667-.205 1.571.965 1.328 1.764-.268.883-.937 6.126-1.499 6.498"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3642A",
    d: "m201.165 21.607 5.4-2.237m-10.136-1.453 1.433-4.096m-9.6 4.216-3.375-4.068m7.545 3.375-.281-4.341M193.874 35.277c-.583-.314-1.393-1.192-3.026-.812"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F2317",
    fillRule: "evenodd",
    d: "M265.752 95.503c2.188 1.516 4.789 2.717 5.599 5.24.875 2.732.673 6.068-1.287 8.206-1.838 2.004-4.998 1.277-7.704 1.596-2.295.271-4.615 1.139-6.661.101-2.223-1.127-4.206-3.206-4.349-5.681-.135-2.332 2.569-3.636 3.692-5.702 1.357-2.497.749-6.487 3.447-7.434 2.682-.941 4.95 2.07 7.263 3.674",
    clipRule: "evenodd",
    opacity: 0.9
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3642A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m258.161 96.02-4.247 2.29 3.966 3.711m3.559-5.292 3.95 4.064-4.23 1.938m-2.231 3.44 3.95 4.064 7.297-5.554"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F2317",
    fillRule: "evenodd",
    d: "M136.748 77.6c3.501.392 5.559 3.97 7.198 6.922 1.625 2.928 3.613 6.584 1.784 9.263-1.786 2.616-6.137 1.512-9.471 1.996-1.894.275-3.631.416-5.555.186-2.765-.33-6.036.236-7.852-1.788-1.968-2.195-2.302-5.6-.977-8.056 1.23-2.28 4.76-1.94 7.091-3.276 2.839-1.627 4.39-5.625 7.782-5.246",
    clipRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#D46C3B",
    d: "M118.61 90.734a11 11 0 0 1-.483.155s.182-.065.483-.155M139.989 82.755c1.252-.481 2.627-2.21 2.627-2.21s-1.622.977-2.627 2.21"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3642A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M122.803 80.675s-2.76.396-3.667 1.625c-1.603 2.171 4.548 3.027 3.644 5.51-.715 1.962-4.653 3.079-4.653 3.079s2.968-1.057 4.71-.56c2.779.79.9 5.911 3.839 5.932 1.554.01 3.667-1.625 3.667-1.625m1.822-17.602s2.434-4.767 3.472-2.047l2.659 6.964c1.038 2.72 4.32-1.406 4.32-1.406s-2.902 1.747-3.346 3.519c-.588 2.345 4.419 3.257 2.991 5.29-.877 1.247-3.667 1.625-3.667 1.625"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#D46C3B",
    stroke: "#E3642A",
    d: "M129.687 85.947c.326.706.053 1.36-.387 1.556-.441.195-1.122-.037-1.447-.743-.326-.706-.053-1.36.387-1.556.441-.195 1.122.037 1.447.743Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3642A",
    stroke: "#E3642A",
    d: "M134.947 82.96c.189.41.011.734-.176.818-.188.083-.554-.001-.743-.412-.189-.41-.012-.735.176-.818.187-.083.553 0 .743.411Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 20.281,
    height: 59.93,
    x: 224.633,
    y: 63.891,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.956863 0 0 0 0 0.552941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5138_1251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5138_1251",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumPartnerBannerIllustrationLargeDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-partner-banner-illustration-large-dark.918381261560e8b1da54114172f0275a.svg";